"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var MerchandiseIds = _interopRequireWildcard(require("self-service-api/constants/MerchandiseIds"));

var _Marketing_Starter = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Starter.svg"));

var _Marketing_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Pro.svg"));

var _Marketing_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Marketing_Ent.svg"));

var _Sales_Starter = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Starter.svg"));

var _Sales_Starter_white = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Starter_white.svg"));

var _Sales_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Pro.svg"));

var _Sales_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Sales_Ent.svg"));

var _Service_Starter = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Service_Starter.svg"));

var _Service_Starter_white = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Service_Starter_white.svg"));

var _Service_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Service_Pro.svg"));

var _Service_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/Service_Ent.svg"));

var _CMS_Pro = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/CMS_Pro.svg"));

var _CMS_Ent = _interopRequireDefault(require("bender-url!pricing-pages-unified-ui/img/productIcons/CMS_Ent.svg"));

var _MerchandiseIds$PRODU;

var _default = (_MerchandiseIds$PRODU = {}, (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_STARTER_NOV_2019, {
  title: 'pricing-pages.hubTiers.starter.title',
  icon: _Marketing_Starter.default,
  includes: "pricing-pages.merchandise.marketing-starter.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_STARTER_MC, {
  title: 'pricing-pages.hubTiers.starter.title',
  icon: _Marketing_Starter.default,
  includes: "pricing-pages.merchandise.marketing-starter.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _Marketing_Pro.default,
  includes: "pricing-pages.merchandise.marketing-professional.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_MC, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _Marketing_Pro.default,
  includes: "pricing-pages.merchandise.marketing-professional.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _Marketing_Ent.default,
  includes: "pricing-pages.merchandise.marketing-enterprise.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_MC, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _Marketing_Ent.default,
  includes: "pricing-pages.merchandise.marketing-enterprise.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020, {
  title: 'pricing-pages.hubTiers.starter.title',
  icon: _Sales_Starter.default,
  includes: "pricing-pages.merchandise.sales-starter.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus',
  alternateIcon: _Sales_Starter_white.default
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _Sales_Pro.default,
  includes: "pricing-pages.merchandise.sales-professional.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SALES_ENTERPRISE, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _Sales_Ent.default,
  includes: "pricing-pages.merchandise.sales-enterprise.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020, {
  title: 'pricing-pages.hubTiers.starter.title',
  icon: _Service_Starter.default,
  includes: "pricing-pages.merchandise.service-starter.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus',
  alternateIcon: _Service_Starter_white.default
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _Service_Pro.default,
  includes: "pricing-pages.merchandise.service-professional.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.professional.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _Service_Ent.default,
  includes: "pricing-pages.merchandise.service-enterprise.includes",
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_CMS_PROFESSIONAL, {
  title: 'pricing-pages.hubTiers.professional.title',
  icon: _CMS_Pro.default,
  lowerTierPlus: 'pricing-pages.hubTiers.starter.freeTierPlus'
}), (0, _defineProperty2.default)(_MerchandiseIds$PRODU, MerchandiseIds.PRODUCT_CMS_ENTERPRISE, {
  title: 'pricing-pages.hubTiers.enterprise.title',
  icon: _CMS_Ent.default,
  lowerTierPlus: 'pricing-pages.hubTiers.enterprise.lowerTierPlus'
}), _MerchandiseIds$PRODU);

exports.default = _default;
module.exports = exports.default;